import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../../store";
import { LinkAppConfig } from "winslow-core";

export type ConnectedApp = {
  id: string;
  userId: string;
  linkedAppId: string;
  slug: { accessToken: string; refreshToken?: string; expiresIn?: string };
};

export type ConnectedAppsState = {
  connectedApps: ConnectedApp[];
  supportedApps: LinkAppConfig[];
};

const initialState = {
  connectedApps: [],
  supportedApps: [],
} as ConnectedAppsState;

export const connectedAppsSlice = createSlice({
  name: "connectedApps",
  initialState,
  reducers: {
    setConnectedApps: (state: ConnectedAppsState, action) => {
      state.connectedApps = action.payload;
    },
    setSupportedApps: (state: ConnectedAppsState, action) => {
      state.supportedApps = action.payload;
    },
  },
});

export const { setConnectedApps, setSupportedApps } =
  connectedAppsSlice.actions;

export const selectConnectedApps = (state: RootState) =>
  state.connectedApps.connectedApps;

export const selectSupportedApps = (state: RootState) =>
  state.connectedApps.supportedApps;

export default connectedAppsSlice.reducer;
